<template>
    <el-drawer
        :title="`${item.id?'编辑':'新增'}任务`"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="700px"
        :before-close="close">

        <div class="panel form fx-g1  ">
            <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                <el-form-item label="任务名称">
                    <el-input v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="标签">
                    <el-input v-model="form.tags" placeholder="多个标签用 ，隔开"></el-input>
                </el-form-item>
                <el-form-item label="是否允许校区共享">
                    <el-switch v-model="form.allowShare"
                               inactive-color="#ff4949">
                    </el-switch>
                </el-form-item>
                <el-form-item label="讲解视频">
                    <el-upload
                        class="upload-demo"
                        action=""
                        :limit="1"
                        :multiple="false"
                        accept="video/mp4"
                        :on-remove="removeVideo"
                        :before-upload="uploadVideo"
                        :file-list="videos">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传一个mp4格式视频文件，且不超过{{num}}M。注意视频必须是H.264编码的，否则可能无法在线播放</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="演示代码">
                    <el-upload
                        class="upload-demo"
                        action=""
                        :limit="1"
                        :multiple="false"
                        :on-remove="removeCode"
                        :file-list="codes">
                        <el-button size="small" type="primary" @click.stop="setTaskCode(form)">
                            {{codes[0] ? "重新编辑" : "去编辑"}}
                        </el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="卡片">
                    <el-upload
                        class="upload-demo"
                        action=""
                        accept="video/mp4,image/*"
                        :on-remove="removeTutorial"
                        :before-upload="uploadTutorial"
                        multiple
                        :file-list="tutorials">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传图片和mp4格式视频文件，且不超过{{num}}M。注意视频必须是H.264编码的，否则可能无法在线播放</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="随堂资料">
                    <el-upload
                        class="upload-demo"
                        action=""
                        accept="image/*,text/plain,application/zip,application/rar,application/vnd.ms-powerpoint,application/msword,application/vnd.ms-excel,application/pdf"
                        :on-remove="removeattachment"
                        :before-upload="uploadattachment"
                        multiple
                        :file-list="attachments">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传压缩文件或者Office、Pdf文档，且不超过{{num}}M。</div>
                    </el-upload>
                </el-form-item>
                <!-- <el-form-item label="设置知识点">
                    <el-tree ref="tree"
                        class="fx-g1 func_tree"
                        :data="navs"
                        show-checkbox
                        node-key="id"
                        :default-expand-all="true"
                        :default-checked-keys="form.knowledgeIds"
                        :expand-on-click-node="false"
                        :props="defaultProps">
                    </el-tree>
                </el-form-item> -->
                <el-form-item label="设置知识点">
                    <el-cascader placeholder="任务知识点筛选" style="width:400px;"
                        v-model="knowledgeIds" clearable
                        :options="options"
                        :props="{expandTrigger: 'hover',
                        multiple: true
                        }"
                        :show-all-levels="false"
                        @change="handleChange"></el-cascader>
                </el-form-item>

            </el-form>
        </div>
        <span class="fx fx-center">
            <el-button type="primary" @click="sub()">确 定</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>

</template>

<style scoped>

</style>


<script>

    import {mapMutations} from "vuex";
    export default {
        props: [
            "item",
            "showBox",
        ],
        data() {
            return {
                show: false,
                form: {...this.item,"knowledgeIds": (this.item.knowledgeIds ? this.item.knowledgeIds.split(",") : [])},
                knowledgeIds:[],
                videos: this.item.videos ? [...this.item.videos]: [],
                codes: this.item.codes ? [...this.item.codes] : [],
                tutorials: this.item.tutorials ? [...this.item.tutorials] : [],
                attachments: this.item.attachments ? [...this.item.attachments] : [],
                navs: [],
                options: [],
                defaultProps: {
                    children: 'children',
                    label: 'name',
                    disabled: true
                },
                num:0,
            }

        },

        watch: {
            "item": function (newData) {
                this.form = newData;
            },
            "num":function () {
                console.log(this.num)
            },
        },

        methods: {
            ...mapMutations([
                "addStorageHandler",
                "removeStorageHandler",
            ]),
            handleChange(value) {
                console.log(value);
            },
            close() {
                this.$emit("close");
            },
            sub() {
                if(this.knowledgeIds.length > 0){
                    for (const i in this.knowledgeIds) {
                        let data = this.knowledgeIds[i];
                        this.knowledgeIds[i] = data[this.knowledgeIds[i].length-1];
                    }
                }
                let resources = [...this.videos, ...this.attachments, ...this.tutorials, ...this.codes];
                let lessonTask = {...this.form, resources: resources,knowledgeIds:this.knowledgeIds.length > 0 ? this.knowledgeIds.join(",") : null};
                this.$ajaxPost("/lessonTask/save", {
                    lessonTask: lessonTask
                }, (data) => {
                    this.$emit("submit", [lessonTask.lessonId]);
                })
            },
            uploadVideo(file) {
                var fileSize = (file.size / 1024).toFixed(2);
                if (file.size / 1048576 > this.num) {
                    this.$showError("禁止上传超过"+this.num+"M大小文件");
                } else {
                    this.$uploadQiniu(file, "lessontask/").then((file) => {
                        file.category = 1;
                        file.fileSize = fileSize;
                        this.$set(this.videos, 0, file);
                    })
                }
                return false;
            },
            removeVideo(file) {
              this.videos.splice(0, 1);
            },
            setTaskCode(task) {
                // 临时字段，设置一个标识，拱多页面间数据共享用
                // 应该用id的，但是新增课程没有id，只能用这个了
                if (!task.caseFlag) {
                    task.caseFlag = new Date().getTime();
                }
                let key = "task_case_"+task.caseFlag;

                let _this = this;
                // let handler = function(event) {
                //     let data = event.data; //{type: "case_code", id:key, url:"七牛地址"}

                //     if(data.type == "case_code" && data.id == key) {
                //         console.debug("成功保存示例代码", data);
                //         _this.$showSuccess("检测到示例代码成功保存", 5000);
                //         let code = _this.codes[0];
                //         if (code) {
                //             _this.$set(code, "url", data.url);
                //         } else {
                //             _this.$set(_this.codes, 0, {category:3, url: data.url, name: "示例代码"});
                //         }

                //         window.removeEventListener("message",handler, false);
                //     }
                // }
                // /**
                //  * 跨域页面通信 处理，参考https://developer.mozilla.org/zh-CN/docs/Web/API/Window/postMessage
                //  * 目前主要是 课程任务的示例代码编辑
                //  */
                // window.addEventListener("message", handler, false)


                this.addStorageHandler({
                    key: key,
                    handler: (e) => {
                        if (e.key == key) {
                            console.debug("成功保存示例代码", e);
                            this.$showSuccess("检测到示例代码成功保存", 5000);
                            let code = this.codes[0];
                            if (code) {
                                this.$set(code, "url", e.newValue);
                            } else {
                                this.$set(this.codes, 0, {category:3, url: e.newValue, name: "示例代码"});
                            }

                        }
                    }
                })
                let codeUrl = this.codes[0] ? this.codes[0].url : "";
                localStorage.setItem(key, codeUrl)
                this.$goEditCode(this.form.type,"mode=case&id="+key);
                this.$showWarn("请到新打开的页面中编辑代码，编辑完成后点击上方的【保存代码】按钮", 5000);

            },
            removeCode() {
                this.form.codes.splice(0, 1);
            },
            uploadattachment(file) {
                var fileSize = (file.size / 1024).toFixed(2);
                if (file.size / 1048576 > this.num) {
                    this.$showError("禁止上传超过"+this.num+"M大小文件");
                } else {
                    this.$uploadQiniu(file, "lessontask/").then((file) => {
                        file.category = 2;
                        file.fileSize = fileSize;
                        this.attachments.push(file);
                    })
                }
                return false;
            },
            removeattachment(file) {
                this.attachments = this.attachments.filter(item => item.uid != file.uid);
            },
            uploadTutorial(file) {
                var fileSize = (file.size / 1024).toFixed(2);
                if (file.size / 1048576 > this.num) {
                    this.$showError("禁止上传超过"+this.num+"M大小文件");
                } else {
                    this.$uploadQiniu(file, "lessontask/").then((file) => {
                        file.category = 4;
                        file.fileSize = fileSize;
                        this.tutorials.push(file);
                    })
                }
                return false;
            },
            removeTutorial(file) {
                this.tutorials = this.tutorials.filter(item => item.uid != file.uid);
            },
            loadFuncs() {
                this.$ajaxPost("/knowledge/knowledgeByTask",{form:{type:this.form.type}} , (data) => {
                    this.options = data.result;
                })
            },
            loadOneFileSizeLimit(){
                this.$ajaxGet("/schoolStrategt/getOneFileSizeLimit", (data) => {
                    this.num = data.result;
                })
            },
        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadOneFileSizeLimit();
            this.loadFuncs();
            if(this.item.id > 0 &&this.item.knowledgeListIds.length > 0){
                this.item.knowledgeListIds.forEach(item => {
                    this.knowledgeIds.push(item.split(","));
                });
            }
        },
        beforeDestroy() {
            //清除Storage回调处理
            if (this.form.caseFlag) {
                this.removeStorageHandler("task_case_"+this.form.caseFlag);
            }
        }

    }
</script>
